<template>
  <div class="sub-menu-container" :class="{
    'sub-menu-active': status || isInvolve,
    'is-fold-active': !status && isInvolve
  }" @click="status=!status">
    <item
      :icon="route.meta.icon"
      :title="route.meta.title"
      :is-active="status || isInvolve"
      :is-unfold="status"
      :is-nest="true"
      :fold="true"
      :tag="route.meta.tag"
      :meta="route.meta"
    />
    <collapse-transition>
      <div v-show="status" class="sub-menu-content">
        <slot></slot>
      </div>
    </collapse-transition>
  </div>
</template>
<script>
import CollapseTransition from '@/components/transitions/collapse-transition'
import Item from './item.vue'
export default {
  components: { CollapseTransition, Item },
  props: {
    route: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    },
    activePath: {
      type: String,
      default: ''
    },
    isUnfold: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isUnfold: {
      handler(newVal) {
        if (newVal && this.isInvolve) {
          this.status = true
        }
        if (!newVal) {
          this.status = false
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      status: false
    }
  },
  computed: {
    isInvolve() {
      // TODO: exact match
      let reg = new RegExp(`^((${this.basePath}/)|(${this.basePath}$))`, 'gi')
      return reg.test(this.activePath);
    }
  }
}
</script>
<style lang="scss" scoped>
.sub-menu-container {
  margin: 0 -12px;
  padding: 0 12px;
  .sub-menu-content {
    padding-bottom: 8px;
  }

  /deep/ {
    .nest-menu-container {

      .sidebar-item-container,
      .nest-menu {

        .item-link-wrapper {
          // height: 44px;
          // padding: 0;
          display: flex;
          align-items: center;
          padding: 12px 0;

          .item-container {
            padding-right: 0;
          }
        }

        .router-link-exact-active {
          background: rgba(#FFF, 0.16);
          border-radius: 8px;
        }

        .item-title {
          font-family: OpenSans;
          font-weight: 500;
        }

        &:hover {
          .item-title {
            color: #FFF;
          }
        }
      }
    }
  }
}

.sub-menu-active {
  background: #00163d;
}

.is-fold-active {
  background: #001c4f;
  .is-active {
    transition: background-color 0.2s;
    background: rgba(#FFF, 0.16) !important;
    border-radius: 8px !important;
  }
}
</style>
